export default "__VITE_ASSET__ci8WCg90__"